<template>
  <path
    d="M6 2.00024C4.9 2.00024 4.01 2.90024 4.01 4.00024L4 20.0002C4 21.1002 4.89 22.0002 5.99 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V8.83024C20 8.30024 19.79 7.79024 19.41 7.42024L14.58 2.59024C14.21 2.21024 13.7 2.00024 13.17 2.00024H6ZM13 8.00024V3.50024L18.5 9.00024H14C13.45 9.00024 13 8.55024 13 8.00024Z"
  />
</template>
